module.exports = __webpack_public_path__ + "img/store-connect-banner.8e6fb5c4.svg";